import DamagedPointsComponent from '@/common/components/adjusterReport/damagedPoints/DamagedPointsComponent';
import ImagePreviewDamagedPointsList from '@/common/components/adjusterReport/damagedPoints/ImagePreviewDamagedPointsList';
import PreviewImageAddDamagedPointModal from '@/common/components/adjusterReport/damagedPoints/PreviewImageAddDamagedPointModal';
import Button from '@/common/components/base/button/Button';
import Typography from '@/common/components/base/typography/Typography';
import MainLayout from '@/common/components/layouts/MainLayout';
import useModal from '@/common/hooks/useModal';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title="بیمه گذار / تصاویر" header="titleHeader">
      <BodyServerDamagedPointsPage />
    </MainLayout>
  );
};

const BodyServerDamagedPointsPage = () => {
  const { closeModal, open, openModal } = useModal();

  return (
    <>
      <PreviewImageAddDamagedPointModal
        closeModal={closeModal}
        open={open}
        roleType="body"
      />
      <DamagedPointsComponent
        needSelectedPoints
        userType="body"
        header={
          <Box mt={24}>
            <Typography color="black-1" textStyle="b2">
              کارشناس محترم، در صورت داشتن نقاط آسیب‌دیده نسبت به ثبت آن اقدام
              نمایید؛ در غیر این صورت می‌توانید این مرحله را رد کنید.
            </Typography>
          </Box>
        }
        pointsList={
          <ImagePreviewDamagedPointsList participantRoleType="body" />
        }
        buttons={
          <Box>
            <Button fullWidth mt={40} onClick={openModal}>
              تایید و ادامه
            </Button>
          </Box>
        }
      />
    </>
  );
};
